import { render, staticRenderFns } from "./CatalogBanners.vue?vue&type=template&id=70f00ffe&"
import script from "./CatalogBanners.vue?vue&type=script&lang=js&"
export * from "./CatalogBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports